module.exports = __webpack_public_path__ + "img/dfwvga-logo-mini.e4c7524b.png";